<template>
  <div class="col-md-12" :style="{ 'min-height': dynHeight }">
    <HeaderLogo :page-type="'1'" :light_logo="true" />

    <div class="row no-padding main-body" :style="{ height: windowHeight }">
      <div class="col-md-12 flex-container">
        <BrandPattern page="CREATEACCOUNT" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import HeaderLogo from "@/components/common/headerLogo.vue";
import BrandPattern from "@/components/prospect/brandPattern/brandPattern2.vue";

defineProps<{
  dynHeight: string;
  windowHeight: string;
}>();
</script>
